/* __next_internal_client_entry_do_not_use__  cjs */ "use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _unsupportedProp = _interopRequireDefault(require("../utils/unsupportedProp"));
var _tabClasses = _interopRequireWildcard(require("./tabClasses"));
var _jsxRuntime = require("react/jsx-runtime");
const useUtilityClasses = (ownerState)=>{
    const { classes, textColor, fullWidth, wrapped, icon, label, selected, disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            "textColor".concat((0, _capitalize.default)(textColor)),
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, _composeClasses.default)(slots, _tabClasses.getTabUtilityClass, classes);
};
const TabRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles["textColor".concat((0, _capitalize.default)(ownerState.textColor))],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                ["& .".concat(_tabClasses.default.iconWrapper)]: styles.iconWrapper
            },
            {
                ["& .".concat(_tabClasses.default.icon)]: styles.icon
            }
        ];
    }
})((0, _memoTheme.default)((param)=>{
    let { theme } = param;
    return {
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom');
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom';
                },
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.icon && ownerState.label;
                },
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: (param)=>{
                    let { ownerState, iconPosition } = param;
                    return ownerState.icon && ownerState.label && iconPosition === 'top';
                },
                style: {
                    ["& > .".concat(_tabClasses.default.icon)]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: (param)=>{
                    let { ownerState, iconPosition } = param;
                    return ownerState.icon && ownerState.label && iconPosition === 'bottom';
                },
                style: {
                    ["& > .".concat(_tabClasses.default.icon)]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: (param)=>{
                    let { ownerState, iconPosition } = param;
                    return ownerState.icon && ownerState.label && iconPosition === 'start';
                },
                style: {
                    ["& > .".concat(_tabClasses.default.icon)]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: (param)=>{
                    let { ownerState, iconPosition } = param;
                    return ownerState.icon && ownerState.label && iconPosition === 'end';
                },
                style: {
                    ["& > .".concat(_tabClasses.default.icon)]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    ["&.".concat(_tabClasses.default.selected)]: {
                        opacity: 1
                    },
                    ["&.".concat(_tabClasses.default.disabled)]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    ["&.".concat(_tabClasses.default.selected)]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    ["&.".concat(_tabClasses.default.disabled)]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    ["&.".concat(_tabClasses.default.selected)]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    ["&.".concat(_tabClasses.default.disabled)]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.fullWidth;
                },
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: (param)=>{
                    let { ownerState } = param;
                    return ownerState.wrapped;
                },
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    };
}));
const Tab = /*#__PURE__*/ React.forwardRef(function Tab(inProps, ref) {
    const props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className, disabled = false, disableFocusRipple = false, // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition = 'top', // eslint-disable-next-line react/prop-types
    indicator, label, onChange, onClick, onFocus, // eslint-disable-next-line react/prop-types
    selected, // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value, wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled,
        disableFocusRipple,
        selected,
        icon: !!iconProp,
        iconPosition,
        label: !!label,
        fullWidth,
        textColor,
        wrapped
    };
    const classes = useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ React.isValidElement(iconProp) ? /*#__PURE__*/ React.cloneElement(iconProp, {
        className: (0, _clsx.default)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) {
            onChange(event, value);
        }
        if (onClick) {
            onClick(event);
        }
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) {
            onChange(event, value);
        }
        if (onFocus) {
            onFocus(event);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, _clsx.default)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)(React.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
"production" !== "production" ? Tab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */ children: _unsupportedProp.default,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: _propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */ disableRipple: _propTypes.default.bool,
    /**
   * The icon to display.
   */ icon: _propTypes.default.oneOfType([
        _propTypes.default.element,
        _propTypes.default.string
    ]),
    /**
   * The position of the icon relative to the label.
   * @default 'top'
   */ iconPosition: _propTypes.default.oneOf([
        'bottom',
        'end',
        'start',
        'top'
    ]),
    /**
   * The label element.
   */ label: _propTypes.default.node,
    /**
   * @ignore
   */ onChange: _propTypes.default.func,
    /**
   * @ignore
   */ onClick: _propTypes.default.func,
    /**
   * @ignore
   */ onFocus: _propTypes.default.func,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */ value: _propTypes.default.any,
    /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */ wrapped: _propTypes.default.bool
} : void 0;
var _default = exports.default = Tab;
